/**
 * Countries where analytics/ads storage needs opt-in consent: the UK, the EEA
 * (EU + Iceland, Liechtenstein, Norway) and Switzerland. Also sent to Google as
 * the `region` of the denied Consent Mode default (see bootstrap.ts).
 */
export const CONSENT_REGIONS: readonly string[] = [
  "GB",
  "AT",
  "BE",
  "BG",
  "HR",
  "CY",
  "CZ",
  "DK",
  "EE",
  "FI",
  "FR",
  "DE",
  "GR",
  "HU",
  "IS",
  "IE",
  "IT",
  "LV",
  "LI",
  "LT",
  "LU",
  "MT",
  "NL",
  "NO",
  "PL",
  "PT",
  "RO",
  "SK",
  "SI",
  "ES",
  "SE",
  "CH",
];

/** True when the visitor must opt in — including when their country is unknown. */
export function requiresConsent(country?: string | null): boolean {
  if (!country) return true;
  return CONSENT_REGIONS.includes(country.toUpperCase());
}
